import { Directive, AfterViewInit, ElementRef, ChangeDetectorRef, Input } from '@angular/core';
import { SelectorService } from '../controls/base/selector.service';
@Directive({
  selector: '[sepidzAutoFocus]'
})
export class AutoFocusDirective implements AfterViewInit {
  constructor(private el: ElementRef, private selectorService: SelectorService) { }

  ngAfterViewInit() {
    setTimeout(() => {
      if (!this.selectorService.onFocused) {
        const invalidControl = this.el.nativeElement.querySelector('.ng-invalid');
        if (invalidControl)
          invalidControl.focus();
        else
          this.el.nativeElement.focus();
        this.selectorService.onFocused = true;
      }
    }, 200);
  }
}
